/**
 *	(c) 2024 Приволжский Исследовательский Медицинский Университет
 *
 *	@file: Subscribe_Page.js
 *  @description: Этот файл является частью клиентской стороны проекта. Относится к части, которая содержит существенную часть проекта - страницы атласа. Страница подписки отвечает за отображение страницы подписки.
 *	@author: Манжос Геннадий Юрьевич
*/
import React, { useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import './Subscribe_Page.css';
import { motion } from 'framer-motion';

const Subscribe_Page = observer(() => {
    const history = useNavigate();
    const { t } = useTranslation();
    const pageRef = useRef(null);

    useEffect(() => {
        // Динамический расчет высоты с учетом футера
        const calculateHeight = () => {
            if (pageRef.current) {
                const footer = document.querySelector('footer');
                const footerHeight = footer ? footer.offsetHeight : 0;
                pageRef.current.style.minHeight = `calc(70vh - ${footerHeight}px)`;
            }
        };

        calculateHeight();
        window.addEventListener('resize', calculateHeight);

        return () => window.removeEventListener('resize', calculateHeight);
    }, []);

    return (
        <div className='subscribe_page' ref={pageRef}>
            <div className='subscribe_content_container'>
                <motion.div
                    className='subscribe_bottom_border'
                    initial={{ x: -100, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                />
                <motion.div
                    className='subscribe_left_border'
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
                />
                <div className="subscribe_content_box">
                    <h2 className="subscribe_title">
                        {t('Subscription is provided by upgrading')}
                    </h2>
                    
                    <div className="subscribe_contacts">
                        <p>{t('connect us')}:</p>
                        <ul>
                            <li>{t('e-mail')} <b><a href="mailto:sale@pimunn.net"> {t('e-mail address')}</a></b></li>
                            <li>{t('contact phone')} <b>{t('phone number')}</b></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default Subscribe_Page;